module.exports = {
  anesthetist: {
    key: 'anesthetist',
    label: 'Anesthetist',
  },
  burnSurgeon: {
    key: 'burnSurgeon',
    label: 'Burn Surgeon',
  },
  certifiedNurseAssistant: {
    key: 'certifiedNurseAssistant',
    label: 'Certified Nurse Assistant',
  },
  chargeNurse: {
    key: 'chargeNurse',
    label: 'Charge Nurse',
  },
  clinicalCoordinator: {
    key: 'clinicalCoordinator',
    label: 'Clinical Coordinator',
  },
  doctor: {
    key: 'doctor',
    label: 'Doctor',
  },
  emergencyDoctor: {
    key: 'emergencyDoctor',
    label: 'Emergency Doctor',
  },
  fellow: {
    key: 'fellow',
    label: 'Fellow',
  },
  floorNurse: {
    key: 'floorNurse',
    label: 'Floor Nurse',
  },
  icuNurse: {
    key: 'icuNurse',
    label: 'ICU Nurse',
  },
  inpatientNurse: {
    key: 'inpatientNurse',
    label: 'Inpatient Nurse',
  },
  inpatientNursePractitioner: {
    key: 'inpatientNursePractitioner',
    label: 'Inpatient Nurse Practitioner',
  },
  nurse: {
    key: 'nurse',
    label: 'Nurse',
  },
  nursePractitioner: {
    key: 'nursePractitioner',
    label: 'Nurse Practitioner',
  },
  nutritionist: {
    key: 'nutritionist',
    label: 'Nutritionist',
  },
  occupationalTherapist: {
    key: 'occupationalTherapist',
    label: 'Occupational Therapist',
  },
  other: {
    key: 'other',
    label: 'Other',
  },
  outpatientNurse: {
    key: 'outpatientNurse',
    label: 'Outpatient Nurse',
  },
  outpatientNursePractioner: {
    key: 'outpatientNursePractioner',
    label: 'Outpatient Nurse Practioner',
  },
  physicalTherapist: {
    key: 'physicalTherapist',
    label: 'Physical Therapist',
  },
  psychologist: {
    key: 'psychologist',
    label: 'Psychologist',
  },
  resident: {
    key: 'resident',
    label: 'Resident',
  },
  surgeon: {
    key: 'surgeon',
    label: 'Surgeon',
  },
};
